import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';

export default Vue.component('upcoming-payments', {
  name: 'UpcomingPayments',
  props: {
    'providerId': { type: [String, Number] }
  },
  components: {
    VueSimpleSpinner
  },
  mixins: [ HttpMixin ],
  data () {
    return {
      cardExpanded: false,
      payments: []
    };
  },
  async created () {
    await this.expandCard();
  },
  methods: {
    async expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.fetch();
      }
    },
    async fetch() {
      const data = await (this as any).httpGet(`/providers/${this.providerId}/payments?isPast=false`, 'An error occurred retrieving Upcoming Payments.');
      if (data) {
        this.payments = data;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/payments/cards/upcoming/UpcomingPayments.ts